<template>
    <section class="home-container">
        <MasterPage title="患者食谱">
            <div slot="title-icon">
                <Icon type="md-analytics" />
            </div>
            <div slot="searchContent" class="search-content-slot">
                <Form :label-width="80">
                    <Row>
                        <Col span="12">
                        <FormItem label="患者用户：">
                            <Select v-model="select.userId" clearable placeholder="请选择">
                                <Option v-for="item in userAllList" :value="item.id" :key="item.id">
                                    {{ item.name }}
                                </Option>
                            </Select>
                        </FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem label="模板状态：">
                            <Select v-model="select.isDeleted" @on-change="pageNum = 1" placeholder="请选择">
                                <Option value="false">启用</Option>
                                <Option value="true" >禁用</Option>
                            </Select>
                        </FormItem>
                        </Col>
                    </Row>
                </Form>
            </div>
            <div slot="btns">
                <Button type="info" icon="ios-search" @click="pageFindItem">查询</Button>
            </div>
            <div slot="paddingContent">
                <Table stripe :loading="tableLoading" :columns="columns1" :data="dataList"></Table>
            </div>
            <div slot="pager">
                <Page :total="pageTotal" @on-change="pageChange" @on-page-size-change="pageSizeChange" :page-size="pageSize" show-total show-elevator show-sizer/>
            </div>
        </MasterPage>
        <Modal v-model="updateModel" title="修改患者食谱" width="800" @on-cancel="cancelItem">
            <Form :label-width="80">
                <FormItem label="患者用户：">
                    <Select v-model="updateInfoItem.userId" placeholder="请选择">
                        <Option v-for="item in userAllList" :value="item.id" :key="item.id">
                            {{ item.name }}
                        </Option>
                    </Select>
                </FormItem>
            </Form>
            <Table border stripe :columns="columnsAdd" :data="itemAdd">
                <template v-for="week in weekList" slot-scope="{ row, index }" :slot="week">
                    <Form style="margin: 10px 0">
                        <Row v-if="templateInfo.type==row[week]" v-for="(templateInfo,indes) in updateInfoItem.infoList" :key="templateInfo.key">
                            <Col span="12">
                            <FormItem style="margin: 10px 5px">
                                <Select @on-change="changeSelect($event,templateInfo)"
                                        :transfer="true" filterable v-model="templateInfo.foodMaterialId" placeholder="请选择食材">
                                    <Option v-for="item in foodMaterialAllList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                                </Select>
                            </FormItem>
                            </Col>
                            <Col span="6">
                            <FormItem style="margin: 10px 5px">
                                <InputNumber :min="0" v-model="templateInfo.value"
                                             :formatter="value => `${value}${templateInfo.unit}`"
                                             :parser="value => value.replace(templateInfo.unit, '')"
                                             placeholder="请输入食材数量"></InputNumber>
                            </FormItem>
                            </Col>
                            <Col span="2">
                            <Tooltip :transfer="true" placement="top" content="备注" theme="light">
                                <Poptip :transfer="true" placement="right">
                                    <Button class="my_Button" style="border: 0px;padding: 0px;background-color: inherit;line-height: 4;">
                                        <Icon type="md-git-network" size="20" />
                                    </Button>
                                    <div class="api" slot="content">
                                        <Input type="text" v-model="templateInfo.remark" placeholder="请输入备注" />
                                    </div>
                                </Poptip>
                            </Tooltip>
                            </Col>
                            <Col span="4">
                            <FormItem style="margin: 10px 5px">
                                <Button @click="removeInfoList(indes)">删除</Button>
                            </FormItem>
                            </Col>
                        </Row>
                        <Row>
                            <FormItem style="margin: 10px 5px">
                                <Button type="dashed" long @click="addInfoList(row[week])" icon="md-add">添加新的食物</Button>
                            </FormItem>
                        </Row>
                    </Form>
                </template>
            </Table>
            <Form :label-width="60">
                <Row style="padding: 20px 0 0">
                    <Col span="7" offset="4">
                    <FormItem label="开始时间" style="margin:0">
                        <DatePicker v-model="updateInfoItem.startTime" type="datetime" format="yyyy-MM-dd HH:mm" placeholder="请选择问卷开始时间" ></DatePicker>
                    </FormItem>
                    </Col>
                    <Col span="7" offset="2">
                    <FormItem label="结束时间" style="margin:0">
                        <DatePicker v-model="updateInfoItem.endTime" type="datetime" format="yyyy-MM-dd HH:mm" placeholder="请选择问卷结束时间" ></DatePicker>
                    </FormItem>
                    </Col>
                </Row>
            </Form>
            <div slot="footer">
                <Button type="text" size="large" @click="cancelItem">取消</Button>
                <Button type="primary" size="large" :loading="updateLoading" @click="updateItem">确定</Button>
            </div>
        </Modal>
        <Modal v-model="infoModel" title="食谱详情" width="1050">
            <Table border stripe :columns="columnsIndo" :data="itemAdd"></Table>
        </Modal>
    </section>
</template>

<script>
    import MasterPage from '@/components/Master'
    export default {
        components:{
            MasterPage
        },
        data(){
            return{
                columns1: [
                    {
                        type: 'index',
                        width: 80,
                        align: 'center'
                    },
                    {
                        title: '患者账号',
                        align: 'center',
                        render: (h, params) => {
                            this.userAllList.forEach((user) => {
                                if (user.id == params.row.userId){
                                    return this.dataList[params.index]['username'] = user.name
                                }
                            })
                            return h("span",this.dataList[params.index].username)
                        }
                    },
                    {
                        title: '开始时间',
                        align: 'center',
                        render: (h, params) => {
                            let time = new Date(params.row.startTime)
                            let y = time.getFullYear();
                            let m = (time.getMonth()+1) < 10 ? '0' + (time.getMonth()+1):(time.getMonth()+1);
                            let d = time.getDate() < 10 ? '0' + time.getDate() : time.getDate();
                            let hx = time.getHours()< 10 ? '0' + time.getHours() : time.getHours()
                            let mm = time.getMinutes()< 10 ? '0' + time.getMinutes() : time.getMinutes()
                            let s = time.getSeconds()< 10 ? '0' + time.getSeconds() : time.getSeconds()
                            return h("span",y+'-'+m+'-'+d+' '+hx+':'+mm+':'+s)
                        }
                    },
                    {
                        title: '结束时间',
                        align: 'center',
                        render: (h, params) => {
                            let time = new Date(params.row.endTime)
                            let y = time.getFullYear();
                            let m = (time.getMonth()+1) < 10 ? '0' + (time.getMonth()+1):(time.getMonth()+1);
                            let d = time.getDate() < 10 ? '0' + time.getDate() : time.getDate();
                            let hx = time.getHours()< 10 ? '0' + time.getHours() : time.getHours()
                            let mm = time.getMinutes()< 10 ? '0' + time.getMinutes() : time.getMinutes()
                            let s = time.getSeconds()< 10 ? '0' + time.getSeconds() : time.getSeconds()
                            return h("span",y+'-'+m+'-'+d+' '+hx+':'+mm+':'+s)
                        }
                    },
                    {
                        title: '状态',
                        align: 'center',
                        render: (h, params) => {
                            if (this.dataList[params.index].isDeleted){
                                return h('span', '已禁用')
                            }else{
                                return h('span', '已启用')
                            }
                        }
                    },
                    {
                        title: '操作',
                        align: 'center',
                        minWidth:200,
                        render: (h, params) => {
                            let Buttons = [
                                h('Button', {
                                    props: {
                                        type: 'primary',
                                        icon:'ios-list-box',
                                        label:"small",
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: () => {
                                            this.infoItem_modal(this.dataList[params.index])
                                        }
                                    }
                                }, '详情')
                            ]
                            if (this.dataList[params.index].isDeleted){
                                Buttons.push(
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            icon:'md-unlock',
                                            label:"small",
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.reuseItem_modal(this.dataList[params.index])
                                            }
                                        }
                                    }, '启用')
                                )
                            }else{
                                Buttons.push(
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            icon:'md-create',
                                            label:"small",
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.updateItem_modal(this.dataList[params.index])
                                            }
                                        }
                                    }, '编辑')
                                )
                                Buttons.push(
                                    h('Button', {
                                        props: {
                                            type: 'error',
                                            icon:'md-trash',
                                            label:"small",
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.deleteItem_modal(this.dataList[params.index])
                                            }
                                        }
                                    }, '禁用')
                                )
                            }
                            return h("div",Buttons)
                        }
                    }
                ],
                dataList: [],
                tableLoading:false,
                addTableLoading:false,
                addModel:false,
                addLoading:false,
                addLoadings:false,
                updateModel:false,
                updateLoading:false,
                infoModel:false,
                userAllList:[],
                dietPlanTemplateAllList:[],
                select:{
                    userId:'',
                    isDeleted:'false',
                },
                columnsAdd:[
                    {
                        title: '时间',
                        width: 100,
                        key:'dataTime',
                        align: 'center',
                        fixed: 'left'
                    },
                    {
                        title: '周天',
                        key: 'age',
                        align: 'center',
                        slot:'sev',
                        width: 450,
                    },
                    {
                        title: '周一',
                        align: 'center',
                        slot:'one',
                        width: 450,
                    },
                    {
                        title: '周二',
                        align: 'center',
                        slot:'tow',
                        width: 450,
                    },
                    {
                        title: '周三',
                        key: 'age',
                        align: 'center',
                        slot:'thr',
                        width: 450,
                    },
                    {
                        title: '周四',
                        key: 'age',
                        align: 'center',
                        slot:'fou',
                        width: 450,
                    },
                    {
                        title: '周五',
                        key: 'age',
                        align: 'center',
                        slot:'fiv',
                        width: 450,
                    },
                    {
                        title: '周六',
                        key: 'age',
                        align: 'center',
                        slot:'six',
                        width: 450,
                    },
                ],
                itemAdd:[{dataTime:'早餐',one:'01',tow:'11',thr:'21',fou:'31',fiv:'41',six:'51',sev:'61'},
                    {dataTime:'午餐',one:'02',tow:'12',thr:'22',fou:'32',fiv:'42',six:'52',sev:'62'},
                    {dataTime:'晚餐',one:'03',tow:'13',thr:'23',fou:'33',fiv:'43',six:'53',sev:'63'},
                    {dataTime:'加餐',one:'04',tow:'14',thr:'24',fou:'34',fiv:'44',six:'54',sev:'64'}],
                addItemInfo:{
                    name:'',
                    userId:'',
                    startTime:'',
                    endTime:'',
                    infoList:[],
                },
                weekList:['sev','one','tow','thr','fou','fiv','six'],
                infoItem:{infoVOList:[]},
                columnsIndo:[
                    {
                        title: '时间',
                        width: 60,
                        align: 'center',
                        render:(h,params)=>{
                            let week=['早','午','晚','加']
                            return h("span",week[params.index] + "餐")
                        }
                    },
                    {
                        title: '周天',
                        key: 'age',
                        align: 'center',
                        render:(h,params)=>{
                            let code = 6 + "" + (params.index+1)
                            let hList = []
                            this.infoItem.infoVOList.forEach(function (infoVO) {
                                if (infoVO.type == code) {
                                    infoVO.infoList.forEach(function (info) {
                                        if (info.remark.length <= 0) {
                                            hList.push(h("div", info.foodMaterial.name+info.value+info.foodMaterial.unit))
                                        } else {
                                            hList.push(h("div", info.foodMaterial.name+info.value+info.foodMaterial.unit + "(" + info.remark + ")"))
                                        }
                                    })
                                    return
                                }
                            })
                            return h("div",hList)
                        }
                    },
                    {
                        title: '周一',
                        align: 'center',
                        render:(h,params)=>{
                            let code = 0 + "" + (params.index+1)
                            let hList = []
                            this.infoItem.infoVOList.forEach(function (infoVO) {
                                if (infoVO.type == code) {
                                    infoVO.infoList.forEach(function (info) {
                                        if (info.remark.length <= 0) {
                                            hList.push(h("div", info.foodMaterial.name+info.value+info.foodMaterial.unit))
                                        } else {
                                            hList.push(h("div", info.foodMaterial.name+info.value+info.foodMaterial.unit + "(" + info.remark + ")"))
                                        }
                                    })
                                    return
                                }
                            })
                            return h("div",hList)
                        }
                    },
                    {
                        title: '周二',
                        align: 'center',
                        render:(h,params)=>{
                            let code = 1 + "" + (params.index+1)
                            let hList = []
                            this.infoItem.infoVOList.forEach(function (infoVO) {
                                if (infoVO.type == code) {
                                    infoVO.infoList.forEach(function (info) {
                                        if (info.remark.length <= 0) {
                                            hList.push(h("div", info.foodMaterial.name+info.value+info.foodMaterial.unit))
                                        } else {
                                            hList.push(h("div", info.foodMaterial.name+info.value+info.foodMaterial.unit + "(" + info.remark + ")"))
                                        }
                                    })
                                    return
                                }
                            })
                            return h("div",hList)
                        }
                    },
                    {
                        title: '周三',
                        key: 'age',
                        align: 'center',
                        render:(h,params)=>{
                            let code = 2 + "" + (params.index+1)
                            let hList = []
                            this.infoItem.infoVOList.forEach(function (infoVO) {
                                if (infoVO.type == code) {
                                    infoVO.infoList.forEach(function (info) {
                                        if (info.remark.length <= 0) {
                                            hList.push(h("div", info.foodMaterial.name+info.value+info.foodMaterial.unit))
                                        } else {
                                            hList.push(h("div", info.foodMaterial.name+info.value+info.foodMaterial.unit + "(" + info.remark + ")"))
                                        }
                                    })
                                    return
                                }
                            })
                            return h("div",hList)
                        }
                    },
                    {
                        title: '周四',
                        key: 'age',
                        align: 'center',
                        render:(h,params)=>{
                            let code = 3 + "" + (params.index+1)
                            let hList = []
                            this.infoItem.infoVOList.forEach(function (infoVO) {
                                if (infoVO.type == code) {
                                    infoVO.infoList.forEach(function (info) {
                                        if (info.remark.length <= 0) {
                                            hList.push(h("div", info.foodMaterial.name+info.value+info.foodMaterial.unit))
                                        } else {
                                            hList.push(h("div", info.foodMaterial.name+info.value+info.foodMaterial.unit + "(" + info.remark + ")"))
                                        }
                                    })
                                    return
                                }
                            })
                            return h("div",hList)
                        }
                    },
                    {
                        title: '周五',
                        key: 'age',
                        align: 'center',
                        render:(h,params)=>{
                            let code = 4 + "" + (params.index+1)
                            let hList = []
                            this.infoItem.infoVOList.forEach(function (infoVO) {
                                if (infoVO.type == code) {
                                    infoVO.infoList.forEach(function (info) {
                                        if (info.remark.length <= 0) {
                                            hList.push(h("div", info.foodMaterial.name+info.value+info.foodMaterial.unit))
                                        } else {
                                            hList.push(h("div", info.foodMaterial.name+info.value+info.foodMaterial.unit + "(" + info.remark + ")"))
                                        }
                                    })
                                    return
                                }
                            })
                            return h("div",hList)
                        }
                    },
                    {
                        title: '周六',
                        key: 'age',
                        align: 'center',
                        render:(h,params)=>{
                            let code = 5 + "" + (params.index+1)
                            let hList = []
                            this.infoItem.infoVOList.forEach(function (infoVO) {
                                if (infoVO.type == code) {
                                    infoVO.infoList.forEach(function (info) {
                                        if (info.remark.length <= 0) {
                                            hList.push(h("div", info.foodMaterial.name+info.value+info.foodMaterial.unit))
                                        } else {
                                            hList.push(h("div", info.foodMaterial.name+info.value+info.foodMaterial.unit + "(" + info.remark + ")"))
                                        }
                                    })
                                    return
                                }
                            })
                            return h("div",hList)
                        }
                    },
                ],
                key:0,
                updateInfoItem:{id:'',userId:'',startTime:'',endTime:'',infoList: []},
                pageNum:1,
                pageSize:20,
                pageTotal:0,
            }
        },
        created(){
            this.pageFindItem()
            this.findAllUser()
            // this.findAllDietPlanTemplate()
            this.findAllFoodMaterial()
        },
        methods:{
            pageChange(value){
                this.pageNum = value
                this.pageFindItem()
            },
            pageSizeChange(value){
                this.pageSize = value
                this.pageFindItem()
            },
            findAllFoodMaterial(){
                this.$http.post('foodMaterial/list',{
                    isDeleted:false,
                    pageSize:0,
                    pageNum:0,
                }).then(function (res) {
                    this.tableLoading = false
                    let msg = res.body
                    if (msg.success) {
                        this.foodMaterialAllList = msg.data.list
                    }else {
                        this.$Notice.error({title:'食材查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.myError(res.body)
                })
            },
            findAllUser(){
                this.$http.post('user/list',{
                    isLock:false,
                    pageSize:0,
                    pageNum:0,
                }).then(function (res) {
                    this.tableLoading = false
                    let msg = res.body
                    if (msg.success) {
                        this.userAllList = msg.data.list
                    }else {
                        this.$Notice.error({title:'患者账户查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.tableLoading = false
                    this.myError(res.body)
                })
            },
            pageFindItem(){
                this.$Message.loading('正在加载中。。。')
                this.tableLoading = true
                this.$http.post('dietPlan/list',{
                    userId:this.select.userId == undefined ? "": this.select.userId,
                    isDeleted:this.select.isDeleted,
                    pageSize:this.pageSize,
                    pageNum:this.pageNum,
                }).then(function (res) {
                    this.tableLoading = false
                    let msg = res.body
                    if (msg.success) {
                        this.dataList = msg.data.list
                        this.pageTotal = msg.data.total
                    }else {
                        this.$Notice.error({title:'饮食计划列表查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.tableLoading = false
                    this.myError(res.body)
                })
            },
            changeSelect(value,templateInfo){
                for (let i = 0 ; i < this.foodMaterialAllList.length ; i++){
                    let obj = this.foodMaterialAllList[i]
                    if (obj.id == value) {
                        templateInfo.unit = obj.unit == ''? "" : obj.unit
                        return
                    }
                }
            },
            addInfoList(week){
                this.updateInfoItem.infoList.push({dietPlanTemplateId:this.updateInfoItem.id,foodMaterialId:'',value:0,type:week,remark:'',unit:'',key:this.key++})
            },
            removeInfoList(index){
                this.updateInfoItem.infoList.splice(index, 1)
            },
            updateItem_modal(item){
                this.updateInfoItem.id = item.id
                this.updateInfoItem.startTime = new Date(item.startTime)
                this.updateInfoItem.endTime = new Date(item.endTime)
                this.updateInfoItem.userId = item.userId
                let infoList = []
                item.infoVOList.map((item)=>{
                    item.infoList.forEach((info)=> {
                        info['key'] = this.key++
                        info['unit'] = info.foodMaterial.unit
                        infoList.push(JSON.parse(JSON.stringify(info)))
                    })
                })
                this.updateInfoItem.infoList = infoList
                this.updateModel = true
            },
            updateItem(){
                if (this.updateInfoItem.userId.length <= 0){
                    return this.$Message.warning('请选择患者账号');
                }
                if (this.updateInfoItem.startTime == undefined || this.updateInfoItem.startTime.length <= 0){
                    return this.$Message.warning('请输入开始时间');
                }
                if (this.updateInfoItem.endTime == undefined || this.updateInfoItem.endTime.length <= 0){
                    return this.$Message.warning('请输入结束时间');
                }
                let flag = false
                this.updateInfoItem.infoList.forEach(function (TemplateInfo) {
                    if (TemplateInfo.foodMaterialId.length <= 0 && TemplateInfo.value != null && TemplateInfo.value <= 0){
                        flag = true
                        return
                    }
                })
                if (flag || this.updateInfoItem.infoList.length <= 0) {
                    return this.$Message.warning('请填写完整数据');
                }
                this.updateLoading = true
                this.$http.post('dietPlan/update',{
                    id:this.updateInfoItem.id,
                    userId:this.updateInfoItem.userId,
                    startTime:this.updateInfoItem.startTime+'',
                    endTime:this.updateInfoItem.endTime+'',
                    infoList:JSON.stringify(this.updateInfoItem.infoList)
                }).then(function (res) {
                    this.cancelItem()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '食谱修改成功'});
                        this.pageFindItem()
                    }else {
                        this.$Notice.error({title:'食谱修改失败',desc: msg.message});
                    }
                },function (res) {
                    this.cancelItem()
                    this.myError(res.body)
                })
            },
            cancelItem(){
                this.addModel = this.addLoading = this.addLoadings = this.updateModel = this.updateLoading = this.infoModel = false
                this.key = 0
                this.addItemInfo.infoList.length = 0
                this.addItemInfo.name = this.addItemInfo.userId = this.addItemInfo.startTime = this.addItemInfo.endTime = ''
            },
            infoItem_modal(item){
                this.infoItem = item
                this.infoModel = true
            },
            reuseItem_modal(item){
                this.$Modal.confirm({
                    title: '确认启用“'+ item.username + '”的食谱',
                    loading:true,
                    onOk: () => {
                        this.reuseItem(item);
                    }
                });
            },
            reuseItem(item){
                this.$http.post('dietPlan/reuse',{
                    id:item.id,
                }).then(function (res) {
                    this.$Modal.remove()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '食谱启用成功'});
                        this.pageFindItem()
                    }else {
                        this.$Notice.error({title:'食谱启用失败',desc: msg.message});
                    }
                },function (res) {
                    this.$Modal.remove()
                    this.myError(res.body)
                })
            },
            deleteItem_modal(item){
                this.$Modal.confirm({
                    title: '确认禁用“'+ item.username + '”的食谱',
                    loading:true,
                    onOk: () => {
                        this.deleteItem(item);
                    }
                });
            },
            deleteItem(item){
                this.$http.post('dietPlan/delete',{
                    id:item.id,
                }).then(function (res) {
                    this.$Modal.remove()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '食谱禁用成功'});
                        this.pageFindItem()
                    }else {
                        this.$Notice.error({title:'食谱禁用失败',desc: msg.message});
                    }
                },function (res) {
                    this.$Modal.remove()
                    this.myError(res.body)
                })
            },
        }
    }
</script>

<style scoped type="scss">
    .home-container{

    }
</style>
